import { RouteConfig } from "vue-router";
const BASE_PATH = "views/agriculturalProduct";
const agriculturalProduct: Array<RouteConfig> = [
  {
    path: "basic-info/agricultural-product",
    name: "agriculturalProduct",
    redirect: { name: "planting" },
    meta: {
      menuMatch: "agriculturalProduct",
    },
    component: () => import(`@/${BASE_PATH}/Main.vue`),
    children: [
      {
        path: "planting",
        name: "planting",
        component: () => import(`@/${BASE_PATH}/plant/Planting.vue`),
        meta: {
          index: "4-1",
        },
      },
      {
        path: "additem",
        name: "additem",
        component: () => import(`@/${BASE_PATH}/plant/addItem/AddItem.vue`),
        meta: {
          index: "4-1",
        },
      },
      {
        path: "job",
        name: "job",
        component: () => import(`@/${BASE_PATH}/jobAccounting/Job.vue`),
        meta: {
          index: "4-2",
        },
      },
      {
        path: "castoff",
        name: "castoff",
        component: () => import(`@/${BASE_PATH}/Castoff.vue`),
        meta: {
          index: "4-3",
        },
      },
      {
        path: "integral",
        name: "integral",
        component: () => import(`@/${BASE_PATH}/integral/Integral.vue`),
        meta: {
          index: "4-4",
        },
      },
      {
        path: "someone",
        name: "someone",
        component: () => import(`@/${BASE_PATH}/integral/someone.vue`),
        meta: {
          index: "4-4",
        },
      },
    ],
  },
];
export default agriculturalProduct;
